import React, { Component } from 'react';
import { Container, Card, CardBody, Button } from 'reactstrap';

import { BusinessInfo, Hours } from './components';

import logo from '../../assets/icon.png';

class Register extends Component {
  // static propTypes = {
  //   error: PropTypes.object,
  //   loginAsync: PropTypes.func.isRequired,
  // };

  // static defaultProps = {
  //   error: undefined,
  // };

  // constructor(props) {
  //   super(props);
  // }

  state = {
    businessName: '',
    email: '',
    phone: '',
    street: '',
    city: '',
    state: '',
    zip: '',
    suite: '',
    hours: {},
  };

  render() {
    return (
      <Container
        style={{
          paddingTop: 130,
          paddingBottom: 30,
          paddingLeft: 30,
          paddingRight: 30,
        }}
      >
        <Card>
          <div style={{ top: -100 }} className="App-logo">
            <img src={logo} alt="logo" style={{ height: 200, borderRadius: 20 }} />
          </div>
          <CardBody style={{ marginTop: -100 }}>
            <div>
              <h1 className="display-6">New Business Submission Form</h1>
              <p className="lead">
                Please provide all of the information below so that we may add your business to the
                People iQ cloud.
              </p>
            </div>
          </CardBody>
          <BusinessInfo
            businessName={this.state.businessName}
            email={this.state.email}
            phone={this.state.phone}
            street={this.state.street}
            city={this.state.city}
            state={this.state.state}
            zip={this.state.zip}
            suite={this.state.suite}
            setBusinessName={businessName => this.setState({ businessName })}
            setEmail={email => this.setState({ email })}
            setPhone={phone => this.setState({ phone })}
            setStreet={street => this.setState({ street })}
            setCity={city => this.setState({ city })}
            setState={state => this.setState({ state })}
            setZip={zip => this.setState({ zip })}
            setSuite={suite => this.setState({ suite })}
          />
          <Hours hours={this.state.hours} />
          <CardBody>
            <Button size="lg">Cancel</Button>{' '}
            <Button className="App-button" size="lg">
              Submit
            </Button>
          </CardBody>
        </Card>
      </Container>
    );
  }
}

export { Register };



// WEBPACK FOOTER //
// ./src/business/register/register.js